<p-button
    [id]="id() + '-btn'"
    [type]="'button'"
    [severity]="severity()"
    [label]="label() === '' ? undefined : (label() | translate)"
    [icon]="icon()"
    [iconPos]="iconPos()"
    [disabled]="disabled()"
    [loading]="loading()"
    [rounded]="rounded()"
    [text]="text()"
    [outlined]="outlined()"
    [link]="link()"
    [size]="size()"
    [styleClass]="class()"
    [pTooltip]="tooltip() | translate"
    [tooltipPosition]="tooltipPosition()"
    [tooltipDisabled]="tooltipDisabled()"
    [attr.aria-disabled]="disabled()"
    [class.glue-left]="glueLeft()"
    [class.glue-right]="glueRight()"
    [class.fluid]="fluid()"
    [class.white-bg]="whiteBg()"
    [style]="style()"
    [attr.aria-hidden]="false"
    (onClick)="onClick.emit($event)">
    <ng-content></ng-content>
</p-button>
